import React from 'react';

class Base extends React.Component {

    render() {
        return this.props.children;
    }
}
export default Base;



// WEBPACK FOOTER //
// ./src/components/Base.js